var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedRoute0)",
    d: "M8.645 5.036a.26.26 0 0 1-.009-.356a2.374 2.374 0 0 1 3.484-.116l1.8 1.787a3.767 3.767 0 0 1 .043 5.237l-2.297 2.388l2.391 2.472a2.63 2.63 0 0 1 .009 3.622a.235.235 0 0 1-.343 0L10.3 16.607a3.767 3.767 0 0 1 .008-5.254l2.28-2.293l-3.943-4.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedRoute1)",
    d: "m11.057 10.594l1.526-1.534a2.786 2.786 0 0 1 .381 3.566l-1.298 1.345c-.489-.493-1.389-1.671-.634-3.317z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedRoute0",
    x1: 15.369,
    x2: 10.453,
    y1: 10.448,
    y2: 10.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3B56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedRoute1",
    x1: 13.255,
    x2: 11.035,
    y1: 10.093,
    y2: 13.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BD4551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3E55"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.09b437060dba5744850608cb1212449a.svg";
export { ForwardRef as ReactComponent };